import React from 'react';
import connectRoute from 'app/routes/connectRoute';
import Dashboard from 'app/components/Dashboard';

export function DashboardPageRoute() {
  return <Dashboard />;
}

export default connectRoute(DashboardPageRoute);
